<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg8 md6>
        <v-flex>
          <v-expansion-panel expand v-model="openPanel">
            <v-expansion-panel-content value="true" class="elevation-5">
              <span class="title" slot="header">Terminal Statistics</span>
              <v-card>
                <v-data-table :headers="headers" :items="itemsTerminal" hide-actions>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left text-uppercase">{{ props.item.terminal }}</td>
                    <td class="text-xs-right">{{ props.item.assigned }}</td>
                    <td class="text-xs-right">{{ props.item.dispatched }}</td>
                    <td class="text-xs-right">{{ props.item.ticket }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-flex>

      <v-flex xs4>
        <v-flex>
          <v-expansion-panel expand v-model="openPanel">
            <v-expansion-panel-content value="true" class="elevation-5">
              <span class="title" slot="header">Running Bus</span>
              <v-card class="pt-2 px-2" style="height:100px">
                <v-layout row justify-center text-xs-center align-center fill-height>
                  <v-flex>
                    <v-icon x-large color="blue">directions_bus</v-icon>
                  </v-flex>

                  <v-flex>
                    <v-layout justify-center text-xs-center>
                      <span class="headline font-weight-black">{{ items.running_bus }}</span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex>
          <v-expansion-panel expand v-model="openPanel">
            <v-expansion-panel-content value="true" class="elevation-5">
              <span class="title" slot="header">Ticket Count</span>
              <v-card class="pt-2 px-2" style="height:100px">
                <v-layout row justify-center text-xs-center align-center fill-height>
                  <v-flex>
                    <v-icon x-large color="red">receipt</v-icon>
                  </v-flex>

                  <v-flex>
                    <v-layout justify-center text-xs-center>
                      <span class="headline font-weight-black">{{ items.ticket_count }}</span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex>
          <v-expansion-panel expand v-model="openPanel">
            <v-expansion-panel-content value="true" class="elevation-5">
              <span class="title" slot="header">Ticket Gross</span>
              <v-card class="pt-2 px-2" style="height:100px">
                <v-layout row justify-center text-xs-center align-center fill-height>
                  <v-flex>
                    <v-icon x-large color="green">toll</v-icon>
                  </v-flex>

                  <v-flex>
                    <v-layout justify-center text-xs-center>
                      <span
                        class="headline font-weight-black"
                      >{{ $amountInPeso(items.ticket_gross) }}</span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
export default {
  data() {
    return {
      company_id: null,
      sub_company_id: null,
      items: [],
      progBar: false,
      queryParams: {
        search: null,
        limit: 10,
        offset: 0
      },
      openPanel: [true],
      headers: [
        {
          text: "TERMINAL",
          align: "left",
          value: "terminal"
        },
        {
          text: "ASSIGNED",
          align: "center",
          value: "assigned"
        },
        {
          text: "DISPATCHED",
          align: "center",
          value: "dispatched"
        },
        {
          text: "TICKET",
          align: "center",
          value: "ticket"
        }
      ],
      itemsTerminal: [],
      value: 0
    };
  },

  computed: {},
  created: async function() {
    await this.getData();
    this.autoRefreshData();
    this.timer = setInterval(this.autoRefreshData, 60000);
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getDashboard(this.queryParams)).data;

        console.log(response.data);

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        this.itemsTerminal = this.items.terminal_statistics;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
      this.progBar = false;
    },
    refreshData() {
      this.progBar = true;
      this.getData();
    },
    async autoRefreshData() {
      try {
        // Query Data
        let response = (await Services.getDashboard(this.queryParams)).data;

        console.log(response.data);

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        this.itemsTerminal = this.items.terminal_statistics;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
    },
    cancelAutoUpdate() {  
      clearInterval(this.timer);  
    },
  },
  beforeDestroy() {  
    this.cancelAutoUpdate();  
  },  
};
</script>

<style>
.scroll {
  overflow-y: auto;
}
</style>